<div *ngIf="state.params?.node?.group">
  <div
    class="cell-group"
    [ngClass]="
      (state.aggData?.child_status && state.firstLeafChild?.typeLabel) || state.params.showChildElements
        ? 'pl-1'
        : 'pl-3'
    "
  >
    <button
      *ngIf="(state.aggData?.child_status && state.firstLeafChild?.typeLabel) || params?.showChildElements"
      mat-icon-button
      class="small-icon-button"
      [intercomTarget]="'row-group-expand-' + state.params.node.rowIndex"
      (click)="toggleOpen(); $event.stopPropagation()"
    >
      <fa-icon
        [icon]="['fal', state.expanded ? 'chevron-down' : 'chevron-right']"
        class="fs-08 text-typography-primary-old"
      ></fa-icon>
    </button>

    <span
      class="truncate cell-group-title"
      [matTooltip]="(state.params.rowGroupingEnabled ? state.path : state.firstLeafChild?.name) ?? ''"
      [attr.data-test]="'y42-entry-group-cell-renderer-entity-' + state.firstLeafChild?.name"
    >
      <ng-container *ngIf="state.params?.rowGroupingEnabled; else firstLeafChildName">
        {{ state.params.value }}
      </ng-container>
      <ng-template #firstLeafChildName>{{ state.firstLeafChild?.name }}</ng-template>
    </span>
    <img
      *ngIf="state.params?.showLogo && state.firstLeafChild?.typeIcon"
      readonly
      width="21"
      class="entry-logo"
      [src]="state.firstLeafChild?.typeIcon"
      alt=""
    />
    <y42-open-in-asset-sidebar-button
      *ngIf="!state.params?.hideDetails"
      class="hover-button-open-in-sidebar"
      [class.active]="state.isActive"
      [path]="state.path"
    ></y42-open-in-asset-sidebar-button>
  </div>
</div>
<div *ngIf="!state.params.node.group && state.params.showLabelWhenNotTree" class="cell-no-group">
  <span class="font-medium text-gray-1100 block truncate" [matTooltip]="state.params.value">
    {{ state.params.value }}
  </span>
  <y42-open-in-asset-sidebar-button
    *ngIf="!state.params?.hideDetails"
    #openInAssetSidebarButton
    class="hover-button-open-in-sidebar"
    [class.active]="openInAssetSidebarButton.state.isActive"
    [path]="state.path"
  ></y42-open-in-asset-sidebar-button>
</div>
